<template>

<v-dialog v-model="dialog" width="400px">
  <v-card>
    <p class=".title ma-2">Move online payment to another booking</p>
    <v-form ref="mvHobo" v-model="mvHoboValid1">

      <br />
      <p class="mx-2">     
       <v-select v-model="hobo_rowid" required :items="hobo_rowidKeuzes" item-value="hobo_rowid" item-text="hobo_oms" label="Payment" dense :rules="hobo_rowidRules"></v-select>
      </p>     
     
      <p class="mx-2">
          <v-text-field v-model="huov_code_moveto" required label="Booking ID where the payment moves to" :rules="huov_code_movetoRules"></v-text-field>
      </p>    
       
      <p v-if="hobo.huov_moveto_huis_code > ''" class="mx-2">
          
      Accommodation: {{hobo.huov_moveto_huis_code}} <br />
      Arrival: {{hobo.huov_moveto_vandat}} Departure: {{hobo.huov_moveto_tmdat}}<br />
      Guest: {{hobo.huov_moveto_klnt}} 
      </p>
      
      


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="hobo.huov_moveto_huis_code > ''" class="primary mx-2" small @click="mvHobo" :disabled="!mvHoboValid1">Move payment</v-btn>
      <v-btn class="primary mx-2" small @click="mvHoboCheck" :disabled="!mvHoboValid1">Check this data</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      mvHoboValid1: false,
      huov_encrid: null,
      hobo_rowid: '',
      huov_code_moveto: null,
      hobo_rowidKeuzes: [],
      hobo: {},
      hobo_rowidRules: [
          v => (v && v.length >= 1) || "An code is required"
      ],
      huov_code_movetoRules: [
          v => (v && v.length >= 1) || "A booking ID is required"
      ]
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.hobo_rowidKeuzes.length = 0;
      this.hobo_dt = '';
      this.hobo_rowid = '';
      this.$axios
        .post("ares/json/ares/huov/hobo/getHoboToMvHobo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHoboToMvHobo"
          },
          getHoboToMvHobo: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hobo = res.data.getHoboToMvHobo;
            res.data.getHoboToMvHobo.hobo_rowidKeuzes.forEach(function(hobo) {
                deze.hobo_rowidKeuzes.push(hobo); 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mvHoboCheck() { 
      this.$axios
        .post("ares/json/ares/huov/hobo/mvHoboCheck.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHoboCheck"
          },
          mvHoboCheck: {
            huov_encrid: this.huov_encrid,
            hobo_rowid: this.hobo_rowid,
            huov_code_moveto: this.huov_code_moveto
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {    
               this.hobo = res.data.mvHoboCheck;  
              if (res.data.mvHoboCheck.color == "error") {
                  this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.mvHoboCheck.text,
                        color: res.data.mvHoboCheck.color
                  }); 
              }  
          }
        })
    },
    mvHobo() { 
      this.$axios
        .post("ares/json/ares/huov/hobo/mvHobo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHobo"
          },
          mvHobo: {
            huov_encrid: this.huov_encrid,
            hobo_rowid: this.hobo_rowid,
            huov_code_moveto: this.huov_code_moveto
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.mvHobo.text,
              color: res.data.mvHobo.color
            }); 
             if (res.data.mvHobo.color == "success" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.mvHobo.huov_encrid); }, 1000); 
            }   
             
            this.dialog = false;
          }
        })
    },
  }
}
</script>

